import { getCurrentDate, getFormattedYear, getAmericanDateFormat } from 'packages/common/utils/format';
import {
  getPayrollReport,
  getPayrollPersonReport,
} from './reportCenterModalService';

export const PROVISION_REPORTS = [
  'COMPETENCE_THIRTEENTH_SALARY_PROVISION',
  'COMPETENCE_VACATION_PROVISION',
];

export const DROPDOWN_ITEM_OPTIONS = [
  { label: 'Gerar Word', value: 'docx' },
  { label: 'Gerar Excel', value: 'xlsx' },
  { label: 'Gerar CSV', value: 'csv' },
];

export const SELECT_ALL_OPTION = '0';

export const RADIO_ESTABLISHMENT_OPTION = 'idEstabelecimento';

export const RADIO_REGISTER_OPTION = 'matricula';

export const CURRENT_DATE_BRAZILIAN = () => getCurrentDate();

export const CURRENT_DATE_AMERICAN = () => getAmericanDateFormat(getCurrentDate());

export const CURRENT_YEAR = () => getFormattedYear(getCurrentDate());

export const REPORTS = [
  {
    endpoint: requestBody => {
      return getPayrollReport(requestBody);
    },
    reports: [
      'SELF_EMPLOYED_PAYMENT_SUMMARY',
      'SELF_EMPLOYED_PAYMENT_LIST',
      'SELF_EMPLOYED_PAYMENT_RECEIPT',
    ],
  },
  {
    endpoint: requestBody => {
      return getPayrollPersonReport(requestBody);
    },
    reports: [
      'INTERN_LIST',
      'INTERN_POINT_CARD',
    ],
  },
];
